export default __webpack_public_path__ + "static/warnings-dark-mode-3b4146df8be5a7042eb77949bf5b5e1a.png";